<template>
  <div class="map-buttons-container">
    <div class="map-buttons">
      <div @click="$emit('center_changed')" style="width:50%">
        <div>このエリアで再検索</div>
      </div>

      <div @click="resetPressed" style="width:50%">
        検索条件クリア
      </div>
    </div>

  </div>
</template>

<script>
import IconSearch from "../assets/icon-search.svg"
import MapUpdate from "../assets/map-update.svg"
import { mapActions, mapGetters } from "vuex"
import { DisplayMode } from "../store/stores"

export default {
  data() {
    return {
      mapUpdate: MapUpdate,
      iconSearch: IconSearch
    }
  },

  computed: {
    searchIcon() {
      if (this.displayMode === DisplayMode.normal) {
        return this.iconSearch
      }

      return this.iconSearchInverted
    },

    searchBackgroundColor() {
      if (this.displayMode == DisplayMode.normal) {
        return "#fff"
      }

      return "#f05353"
    },

    ...mapGetters("stores", ["displayMode"])
  },

  methods: {
    resetPressed() {
      this.resetAll()
      this.exitSearchMode()
    },

    ...mapActions("map", ["zoomIn", "zoomOut"]),
    ...mapActions("nav", ["requestShopListScreen", "requestSearchScreen", "exitSearchMode"]),
    ...mapActions("search", ["resetAll"])
  }
}
</script>

<style>
.map-buttons-container {
  position: fixed;
  left: 50%;
  top: 8.15%;
  transform: translate(-50%, -50%);
  -webkit-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  font-size: 14px;
  width:320px;
}

.map-buttons {
  pointer-events: all;
  align-self: flex-end;
  /* margin-right: 1rem; */
  margin-bottom: 1rem;
  display: flex;
  /* flex-direction: column; */
  background-color: #fff;
  border-radius: 0.5rem;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.161);
  overflow: hidden;
  /* padding: 0px 10px; */
}

.map-buttons > div {
  height: 2.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
  /* color: #f05353; */
  /* font-size: 175%; */
  line-height: 0;
  white-space:nowrap;
  text-align: center;
  margin: 0 auto;
}

.map-buttons > div > span {
  margin-bottom: 5px;
}

.map-buttons > div:not(:last-child) {
  border-right: 1px solid #dedede;
}

@media screen and (width: 375px) {
  .map-buttons-container {
    width: 85%;
    /* bottom: 120px; */
    margin-bottom: 0;
  }
}

@media screen and (max-width: 374px) {
  .map-buttons-container {
    width: 85%;
    /* bottom: 100px; */
    margin-bottom: 0;
  }
}
</style>
